<template>
  <div>
    <div class="back" @click="goBack" style="float:left;">&lt; 上一步</div>
    <div class="bookTitle">{{ this.$route.query.bookName }}</div>
    <div class="common-style">
      <div class="cont-left">
        <div class="addList" @click="openAppend()">新增根目录</div>
        <div class="leftTree">
          <!-- start -->
          <a-tree :treeData="contentList" draggable @drop="onDrop">
            <template slot="custom" slot-scope="item">
              <span
                v-if="!item.showedit"
                @click="getBooklist(item)"
                @contextmenu.prevent="showRight(item)"
              >{{ item.title }}</span>
              <input v-if="item.showedit" @blur="changeName(item)" type="text" v-model="item.title" />
              <a @click="openAppendModal(item)">
                <a-icon type="plus" />
              </a>
              <a @click="editTree(item)">
                <a-icon type="edit" />
              </a>
              <a @click="removeTree(item)">
                <a-icon type="delete" />
              </a>
              <a @click="lockTree(item)" v-if="roles == true">
                <a-icon type="unlock" v-if="item.islock == 0" />
                <a-icon type="lock" v-if="item.islock == 1" />
              </a>
            </template>
          </a-tree>
          <a-modal title="添加目录" v-model="addVisible" cancelText="取消" okText="提交" @ok="appendTree">
            <a-form :form="treeFormData">
              <a-form-item label="目录标题" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                <a-input v-model="treeFormData.name" placeholder="请输入目录标题" style="width:320px;" />
              </a-form-item>
            </a-form>
          </a-modal>
          <!-- over -->
        </div>
      </div>
      <div class="cont-right">
        <h1>{{ rightName }}</h1>
        <div>
          <div class="div-list" v-for="(item, index) in exerciseList" :key="index">
            <p>{{ item.name }}</p>
            <div class="div-box" v-for="(i, index) in item.info" :key="index">
              <span @click="deleteExercise(i)">x</span>
              <p class="title">{{ i.exerciseName }}</p>
              <p
                class="fontStyle"
                style="color:rgba(255, 0, 0, 0.6);"
                v-if="i.stateId == '-1'"
              >文件格式有误，请检查</p>
              <p class="fontStyle" v-if="i.stateId == '0'">等待系统解析</p>
              <p class="fontStyle" style="color:#40A9FF;" v-if="i.stateId == '1'">文件解析中</p>
              <p
                class="fontStyle"
                style="color:rgba(230, 162, 60, 0.8);cursor: pointer;"
                v-if="i.stateId == '2'"
                @click="showDrawer(i)"
              >请设置题目属性</p>
              <!-- 这里新增复制功能 -->
              <!-- <template>
                <a-tooltip>
                  <template slot="title">
                    复制文档
                  </template>
                  <a-icon type="copy" style="color:rgba(230, 162, 60, 0.8);cursor: pointer;" @click="confirmCopy(i)"/>
                </a-tooltip>
              </template>-->
              <!-- 这里结束 -->
              <p
                class="fontStyle"
                style="color:rgba(230, 162, 60, 0.8);cursor: pointer;"
                v-if="i.stateId == '3'"
                @click="showDrawer(i)"
              >上传成功</p>
            </div>
            <!-- 上传文件 -->
            <div class="upLoad">
              <a-upload
                name="file"
                accept=".doc, .docx"
                :beforeUpload="checkSizeFile"
                :showUploadList="false"
                :multiple="false"
                :action="upload.root + 'v1/learnonly/upload/upload1submit'"
                :headers="upload.headers"
                :data="uploadFormData"
                @change="handleChange"
              >
                <div class="upLoadfile" @click="getFromData(item)">上传文件</div>
              </a-upload>
            </div>
          </div>
        </div>
        <div v-if="noData" class="noData" style="margin-top:200px;">
          <p>
            <img src="../../assets/images/noData.png" alt />
          </p>
        </div>
      </div>
      <!-- 右侧滑出查看试题 -->
      <div>
        <a-drawer
          :width="900"
          placement="right"
          :closable="true"
          :title="poptitle"
          @close="onClose"
          :visible="visible"
          :get-container="false"
        >
          <div
            class="drawerList"
            :class="
              item.typeName &&
              item.difficultyName &&
              item.versionChapteNameList.length != 0
                ? ''
                : 'redBorder'
            "
            v-for="(item, index) in questionList"
            :key="index"
          >
            <a-form id="add" :form="form" ref="formbook">
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item v-bind="formItemLayout" label="题型">
                    <a-select
                      @change="changeType($event, item)"
                      placeholder="请选择"
                      size="small"
                      v-model="item.typeName"
                    >
                      <a-select-option
                        v-for="(items, index) in item.typeIdsAndNames"
                        :key="index"
                      >{{ items }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="5">
                  <a-form-item v-bind="formItemLayout1" label="难度">
                    <a-select
                      @change="changeDifficulty($event, item)"
                      placeholder="请选择"
                      size="small"
                      v-model="item.difficultyName"
                    >
                      <a-select-option
                        v-for="(items, index) in item.difficultyTypeIdsAndNames"
                        :key="index"
                      >{{ items }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="13">
                  <a-form-item v-bind="formItemLayout2" label="分类">
                    <a-select
                      placeholder="请选择"
                      size="small"
                      style="width:150px;margin-right:5px;"
                      v-model="item.versionName"
                    >
                      <a-select-opt-group>
                        <span slot="label">
                          <a-icon type="user" />综合库
                        </span>
                        <a-select-option
                          v-for="(items, index) in versionsList['综合库']"
                          :key="index"
                          :value="items"
                          :title="items"
                          @click="changeOutline(index, item, items)"
                        >{{ items }}</a-select-option>
                      </a-select-opt-group>
                      <a-select-opt-group>
                        <span slot="label">
                          <a-icon type="user" />同步库
                        </span>
                        <a-select-option
                          v-for="(items, index) in versionsList['同步库']"
                          :key="index"
                          :value="items"
                          :title="items"
                          @click="changeTextbook(index, item, items)"
                        >{{ items }}</a-select-option>
                      </a-select-opt-group>
                    </a-select>
                    <!-- 树选择 -->
                    <a-tree-select
                      placeholder="请选择"
                      size="small"
                      style="width:220px;"
                      :treeData="item.treeList"
                      @change="
                        (value, lable, extra) =>
                          onChange(value, lable, extra, item)
                      "
                      treeCheckStrictly
                      treeDefaultExpandAll
                      treeCheckable
                      :maxTagCount="1"
                      showCheckedStrategy="SHOW_CHILD"
                      v-model="item.selectTree"
                      dropdownClassName="treeSelectDropdown"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
            <div class="deafaultSort">
              <div>已选分类：</div>
              <div>
                <p v-for="(i, index) in item.versionChapteNameList" :key="index">
                  {{ i.name }}
                  <a-icon
                    type="close-circle"
                    style="color: #f5222d;cursor:pointer"
                    @click="deleteSort(item, i)"
                  />
                </p>
              </div>
            </div>
            <div style="cursor: pointer;padding-top:10px;" @dblclick="editDraw(item)">
              <p v-if="item.mediaData">
                <audio
                  style="width:320px;margin:0;padding:0;"
                  :src="item.mediaData"
                  controls="controls"
                  muted
                ></audio>
              </p>
              <p v-html="item.stem" style="clear:both;padding:0 0 0 5px;"></p>

              <div class="answerStyle">
                <p>
                  【答案】
                  <span v-html="item.answer"></span>
                </p>
                <p>
                  【解析】
                  <span v-html="item.explanation"></span>
                </p>
                <p style="padding-left:5px;">题号：{{ item.id }}</p>
              </div>
            </div>
            <!-- <p style="font-size:13px;padding-left:5px;">
              知识点：
              <a-tag
                v-for="i in item.knowledgepoints"
                :key="i"
                closable
                @close="deleteTag(item.id, i)"
              >
                {{ i }}
              </a-tag>
              <template>
                <a-tag
                  @click="showInput(item)"
                  v-if="!item.tagShow"
                  style="background: #fff; borderStyle: dashed;"
                >
                  <a-icon type="plus" />标签
                </a-tag>
                <a-input
                  v-if="item.tagShow"
                  ref="input"
                  type="text"
                  size="small"
                  :style="{ width: '120px' }"
                  v-model="inputValue"
                  @blur="handleInputConfirm(item, index)"
                />
              </template>
            </p>-->
          </div>

          <!-- 批量设置 -->
          <div class="batchSettings">
            <a-popover
              v-model="settingsVisible"
              trigger="click"
              placement="bottomRight"
              overlayClassName="batchSettingsPopover"
              :overlayStyle="{
                'min-width': '430px',
              }"
            >
              <div slot="content" class="popover-content">
                <div>
                  <span>题型：</span>
                  <a-select
                    placeholder="请选择"
                    size="small"
                    style="width:130px"
                    v-model="allTypeName"
                    @change="allSelectChange"
                  >
                    <a-select-option
                      v-for="(items, index) in typeIdsAndNames"
                      :key="index"
                      :value="index + ',' + '0'"
                    >{{ items }}</a-select-option>
                  </a-select>
                </div>
                <div>
                  <span>难度：</span>
                  <a-select
                    placeholder="请选择"
                    size="small"
                    style="width:156px"
                    v-model="allDifficulty"
                    @change="allSelectChange"
                  >
                    <a-select-option
                      v-for="(items, index) in difficultyTypeIdsAndNames"
                      :key="index"
                      :value="index + ',' + '1'"
                    >{{ items }}</a-select-option>
                  </a-select>
                </div>

                <div style="margin-top:0.5em">
                  <span>分类：</span>
                  <a-select
                    size="small"
                    v-model="versionName"
                    style="width:130px;margin-right:0.5em"
                    @change="allSelectChange"
                    placeholder="请选择"
                  >
                    <a-select-opt-group>
                      <span slot="label">
                        <a-icon type="user" />综合库
                      </span>
                      <a-select-option
                        v-for="(items, index) in versionsLists['综合库']"
                        :key="index + ',' + items"
                        :value="index + ',' + '3'"
                      >{{ items }}</a-select-option>
                    </a-select-opt-group>
                    <a-select-opt-group>
                      <span slot="label">
                        <a-icon type="user" />同步库
                      </span>
                      <a-select-option
                        v-for="(items, index) in versionsLists['同步库']"
                        :key="index + ',' + items"
                        :value="index + ',' + '2'"
                      >{{ items }}</a-select-option>
                    </a-select-opt-group>
                  </a-select>

                  <!-- 树选择 -->
                  <a-tree-select
                    placeholder="请选择"
                    size="small"
                    style="width:220px;"
                    :treeData="treeList"
                    @change="allSelectChange"
                    treeCheckable
                    treeDefaultExpandAll
                    treeCheckStrictly
                    :maxTagCount="1"
                    v-model="allSelectInfo"
                    showCheckedStrategy="SHOW_CHILD"
                    dropdownClassName="treeSelectDropdown"
                  />
                </div>
              </div>
              <a-button type="link">批量设置</a-button>
            </a-popover>
          </div>
        </a-drawer>
      </div>
      <!-- 右侧编辑器 -->
      <div>
        <a-drawer
          :width="980"
          placement="right"
          :closable="true"
          :title="edittitle"
          @close="onCloseedit"
          :visible="editvisible"
          :get-container="false"
        >
          <div class="editPaperPage">
            <div class="btn-Group">
              <a-select
                placeholder="请选择"
                v-model="pageData.typeid"
                style="width: 120px; margin-bottom:20px; margin-right:10px;"
              >
                <template v-for="questionType in listData.questionTypes">
                  <a-select-option
                    :key="questionType.id"
                    :value="questionType.id"
                  >{{ questionType.name }}</a-select-option>
                </template>
              </a-select>

              <a-select
                v-model="pageData.diff"
                style="width: 120px; margin-bottom:20px; margin-right:10px;"
              >
                <template v-for="diff in listData.diffData">
                  <a-select-option :key="diff.id" :value="diff.id">
                    {{
                    diff.label
                    }}
                  </a-select-option>
                </template>
              </a-select>
              <a-select
                v-model="pageData.year"
                style="width: 120px; margin-bottom:20px; margin-right:10px;"
              >
                <template v-for="(year, indexYear) in listData.years">
                  <a-select-option :key="indexYear" :value="year.value">
                    {{
                    year.name
                    }}
                  </a-select-option>
                </template>
              </a-select>
              <a-button type="primary" icon="form" @click="saveChangeData()">修订</a-button>
            </div>

            <a-card title="题文">
              <vue-ueditor-wrap v-model="pageData.stem" :config="config1" @ready="ready"></vue-ueditor-wrap>
            </a-card>

            <a-card title="答案">
              <vue-ueditor-wrap v-model="pageData.answer" :config="config2" @ready="ready"></vue-ueditor-wrap>
            </a-card>

            <a-card title="解析">
              <vue-ueditor-wrap v-model="pageData.explanation" :config="config3" @ready="ready"></vue-ueditor-wrap>
            </a-card>

            <a-card title="音频">
              <div style="position:relative;height:130px;">
                <div style="width:50%;">
                  <a-upload-dragger
                    name="mediaFileData"
                    accept=".mp3, .wav"
                    :disabled="isUploading"
                    :beforeUpload="function(file,fileList){return beforeUploadMedia(file,fileList)}"
                    :showUploadList="false"
                    :multiple="true"
                    :limit="1"
                    :action="upload.root + 'v1/learnonly/upload/uploadMediaFile/' + pageData.quesid"
                    :headers="upload.headers"
                    :data="uploadMediaData"
                    @change="info => uploadMediaHandleChange(info)"
                  >
                    <div style="margin-top:10px;">
                      <p class="ant-upload-drag-icon" style="margin-bottom:10px;">
                        <a-icon type="cloud-upload" size="large" />
                      </p>
                      <p class="ant-upload-text">点击这里上传试题音频附件</p>
                      <p class="ant-upload-hint">支持扩展名：.mp3 .wav，文件大小不超过10M</p>
                    </div>
                  </a-upload-dragger>
                </div>

                <div style="position:absolute;left:50%;width:50%;top:0;">
                  <div
                    style="border-radius:5px;width:100%;height:125px;border:1px dashed #d9d9d9;text-align:center;background:#fafafa;"
                  >
                    <audio
                      style="width:320px;margin:0;padding:0;margin-top:25px;"
                      id="questionAsset"
                      :src="pageData.mediaSrc"
                      controls="controls"
                      muted
                    ></audio>
                    <div style="text-align:center;" v-if="pageData.mediaSrc">
                      <span>
                        <a
                          :href="pageData.mediaSrc"
                          target="_blank"
                          style="color:#f00;"
                        >{{pageData.mediaName}}</a>
                      </span>
                      &nbsp;
                      <span
                        @click="removeMedia()"
                        style="cursor:pointer;"
                      >
                        <a-icon type="close-circle" />移除
                      </span>
                    </div>
                    <div style="text-align:center;" v-else>
                      <span>暂未上传音频文件</span>
                    </div>
                  </div>
                </div>
              </div>
            </a-card>

            <a-card title="来源">
              <a-textarea v-model="pageData.source" placeholder :rows="2" />
            </a-card>

            <!-- <a-card title="等级">
              <a-radio-group v-model="pageData.level">
                <template v-for="level in listData.levels">
                  <a-radio :key="level.id" :value="Number(level.name)">{{
                    level.label
                  }}</a-radio>
                </template>
              </a-radio-group>
            </a-card>

            <a-card title="适用">
              <a-radio-group v-model="pageData.apply">
                <template v-for="apply in listData.applys">
                  <a-radio :key="apply.id" :value="Number(apply.name)">{{
                    apply.label
                  }}</a-radio>
                </template>
              </a-radio-group>
            </a-card>-->
          </div>
        </a-drawer>
      </div>
      <!-- loading -->
      <div class="bodyLoad" v-if="loadLoading">
        <a-spin size="large" />
        <br />
        <p>上传中...</p>
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap"
export default {
  inject: ["reload"],
  components: { VueUeditorWrap },
  data () {
    return {
      // start
      addVisible: false,
      treeFormData: {
        parentid: "",
        bookid: "",
        name: "",
        userid: "",
      },
      // over
      contentList: [],
      roles: "",
      exerciseList: [],
      rightName: "",
      directoryid: "",
      typeList: [],
      noData: true,
      upload: {
        root: process.env.VUE_APP_BASE_API,
        headers: { authorization: this.$store.getters.token },
      },
      uploadFormData: {},
      loadLoading: false,
      poptitle: "",
      settingsVisible: false,
      visible: false,
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
      },
      formItemLayout1: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
      },
      formItemLayout2: {
        labelCol: { span: 3 },
        wrapperCol: { span: 21 },
      },
      selectTree: undefined,
      questionList: [],
      popdataList: {},
      questionid: "",
      typeActive: "",
      difficultyActive: "",
      stageid: "",
      subjectid: "",
      versionid: "",
      typeId: "",
      versionsList: [],
      typeIdsAndNames: [],
      difficultyTypeIdsAndNames: [],
      versionsLists: [],
      treeList: [],
      selectList: {},
      catalogvals: "",
      // 标签
      inputValue: "",
      //编辑器
      editvisible: false,
      edittitle: "",
      listData: {
        questionTypes: [], // 题目类型
        diffData: [
          { id: 0, name: "UNSET", label: "未知" },
          { id: 1, name: "VERY_EASY", label: "容易" },
          { id: 2, name: "EASY", label: "较易" },
          { id: 3, name: "MODERATE", label: "中等" },
          { id: 4, name: "HARD", label: "较难" },
          { id: 5, name: "VERY_HARD", label: "困难" },
        ],
        years: [],
        levels: [
          { id: 1, name: "0", value: "COMMON", label: "普通" },
          { id: 2, name: "1", value: "SPECIAL", label: "特制" },
          { id: 3, name: "2", value: "GOOD", label: "精品" },
        ],
        applys: [
          { id: 1, name: "0", value: "AFTERCLASS", label: "课后" },
          { id: 2, name: "1", value: "INCLASS", label: "课中" },
          { id: 3, name: "2", value: "BEFOREClASS", label: "课前" },
        ],
      },
      // R
      quesid: "",
      pageData: {},
      config1: {
        toolbars: [
          [
            "Undo",
            "Redo",
            "Source",
            "preview", //'FullScreen',  'emotion', 'forecolor','preview',
            "|",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "indent",
            "Bold",
            "italic",
            "underline",
            "fontdotted",
            "strikethrough",
            "superscript",
            "subscript",
            "removeformat",
            "|",
            "snapscreen",
            //'wordimage',
          ], [
            "spechars",
            "simpleupload",
            "insertimage",
            "matheq", // 'pasteplain','mathcas',
            //'|',
            "quesboundary",
            "quesindex1",
            //'|',
            //'quesoption1',
            //'quesoption2', 'quesoption3', 'quesoptionformat',
            "quesblank1",
            "quesblank2",
            "quesblank3",
            "quesblank7",
            "quesblank8",
            "quesblank9",
            "quesblank10",
            "quesblank11",
            "quesblank12",
            "quesblank13",
            "quesindex2",
            /*'quesblank11',*/ "quesoptionformat",
            // 'quesindex2',
            // 'quesoptionformat',
            //"fullscreen",
          ],
        ],
        UEDITOR_HOME_URL: "/ueditor/",
        SERVER_ROOT_URL: process.env.VUE_APP_BASE_API + "v1/learnonly/",
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 工具栏是否可以浮动
        autoFloatEnabled: false,
        // 初始容器高度
        initialFrameHeight: 340,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 关闭自动保存
        enableAutoSave: true,
      },
      config2: {
        toolbars: [
          [
            "Undo",
            "Redo",
            "Source", //'FullScreen',  'emotion', 'forecolor','preview',
            "|",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "indent",
            "Bold",
            "italic",
            "underline",
            "fontdotted",
            "strikethrough",
            "superscript",
            "subscript",
            "removeformat",
            "|",
            "spechars",
            "simpleupload",
            "insertimage",
            "matheq", // 'pasteplain','mathcas',
            "quesindex1",
            "answerblock",
          ],
        ],
        UEDITOR_HOME_URL: "/ueditor/",
        SERVER_ROOT_URL: process.env.VUE_APP_BASE_API + "v1/learnonly/",
        toolbarsAlign: "left",
        wordCount: false, //关闭字数统计
        elementPathEnabled: false, //关闭elementPath
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        initialFrameHeight: 340,
        // 初始容器宽度
        initialFrameWidth: "100%",
      },
      config3: {
        toolbars: [
          [
            "Undo",
            "Redo",
            "Source", //'FullScreen',  'emotion', 'forecolor','preview',
            "|",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "indent",
            "Bold",
            "italic",
            "underline",
            "fontdotted",
            "strikethrough",
            "superscript",
            "subscript",
            "removeformat",
            "|",
            //'wordimage',
            "spechars",
            "simpleupload",
            "insertimage",
            "matheq", // 'pasteplain','mathcas',
            "quesindex1",
            "recorder", //,'fontborder'
            //'|',
            //'quesindex1', 'quesindex2',
            //'|',
            //'quesoption1',
            //'quesoption2', 'quesoption3', 'quesoptionformat',

            //"fullscreen",
          ],
        ],
        UEDITOR_HOME_URL: "/ueditor/",
        SERVER_ROOT_URL: process.env.VUE_APP_BASE_API + "v1/learnonly/",
        toolbarsAlign: "left",
        wordCount: false, //关闭字数统计
        elementPathEnabled: false, //关闭elementPath
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        initialFrameHeight: 340,
        // 初始容器宽度
        initialFrameWidth: "100%",
      },
      // 知识点
      tags: [],
      inputVisible: false,
      allSelectInfo: undefined,
      allTypeName: undefined,
      allDifficulty: undefined,
      versionName: undefined,

      //上传音频
      isUploading: false,
      loadingText: "上传中...",
      uploadMediaData: {},
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },

  watch: {
    questionList: {
      deep: true,
      handler (newVal, oldVal) {
        console.log("newVal", newVal)
        console.log("oldVal", oldVal)
        newVal.forEach((element) => {
          element.selectTree = []
          element.versionChapteNameList.forEach((ele) => {
            element.selectTree.unshift({
              label: ele.name,
              value: ele.id.split("_")[1],
              chapterid: ele.id.split("_")[0],
            })
          })
        })
      },
    },
  },

  methods: {
    // start
    // 请求左侧目录列表
    onSelect () {
      this.$http
        .get("v1/learnonly/directory", {
          params: { bookid: this.$route.query.bookid }, //教辅id
        })
        .then((response) => {
          // response.data.forEach(a => {
          //   a.level = 1
          // })
          if (response.data.data !== null) {
            this.contentList = this.traverse(response.data)
            this.roles = this.$store.getters.roles.includes("admin")
          }
        })
    },
    traverse (data) {
      for (var a in data) {
        data[a].children = data[a].directories
        data[a].title = data[a].name
        data[a].key = data[a].id
        data[a].disabled = false
        data[a].showedit = false
        data[a].scopedSlots = { title: "custom" }
        if (data[a].directories.length) {
          this.traverse(data[a].directories)
        }
      }
      return data
    },
    // 根目录新增
    openAppend () {
      this.treeFormData = {
        parentid: 0,
        bookid: this.$route.query.bookid,
        name: "",
        userid: this.$store.getters.id,
      }
      this.addVisible = true
    },
    openAppendModal (item) {
      // console.log("点击增加图标", item);
      this.treeFormData = {
        parentid: item.id,
        bookid: item.bookId,
        name: "",
        userid: this.$store.getters.id,
      }
      this.addVisible = true
    },
    appendTree () {
      this.$http
        .post("v1/learnonly/directory", this.treeFormData)
        .then((response) => {
          if (response.data) {
            // console.log("添加", response.data);
            this.addVisible = false
            this.onSelect()
          }
        })
    },
    removeTree (data) {
      // console.log(data);
      this.$confirm({
        title: "确认删除该目录下所有目录吗？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.$http
            .delete("v1/learnonly/directory", {
              params: {
                id: data.id,
                bookid: this.$route.query.bookid,
              },
            })
            .then((response) => {
              if (response.status == 200) {
                if (response.data.code == 200) {
                  this.$message.success("删除成功")
                } else {
                  this.$message.error((response.data.message) ? response.data.message : "删除失败")
                }
                this.onSelect()
              }
            })
        },
        onCancel: () => {
          this.$message.info("已取消")
        },
      })
    },
    editTree (item) {
      // console.log("点击修改图标", item);
      this.treeFormData = {
        id: item.id,
        parentid: item.pid,
        bookid: item.bookId,
        name: "",
        userid: this.$store.getters.id,
        sortid: item.sortid,
      }
      item.showedit = !item.showedit
    },
    changeName (item) {
      // console.log("修改走接口", item);
      this.treeFormData.name = item.title
      item.showedit = false
      // this.$http.put('/directory', JSON.stringify(this.treeFormData),{ headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}).then(response => {
      this.$http
        .put("v1/learnonly/directory", this.treeFormData)
        .then((response) => {
          if (response.data) {
            // console.log("修改", response);
            this.onSelect()
          }
        })
    },
    // 解锁
    lockTree (item) {
      var islock = ""
      if (item.islock == 0) {
        islock = 1
      } else {
        islock = 0
      }
      this.treeFormData = {
        id: item.id,
        parentid: item.pid,
        bookid: item.bookId,
        name: item.name,
        userid: this.$store.getters.id,
        sortid: item.sortid,
        islock: islock,
      }
      this.$http
        .put("v1/learnonly/directory", this.treeFormData)
        .then((response) => {
          if (response.data == true) {
            this.$message.success("操作成功")
            this.onSelect()
          } else {
            this.$message.success("操作失败")
          }
        })
    },
    // over
    onDrop (info) {
      // console.log(info)
      const dropKey = info.node.eventKey //被挪到的id
      const dragKey = info.dragNode.eventKey //挪动的id
      const dropPos = info.node.pos.split("-") // 0-1
      // console.log(dropPos)
      const dropPosition =
        info.dropPosition - Number(dropPos[dropPos.length - 1])
      const loop = (data, key, callback) => {
        data.forEach((item, index, arr) => {
          if (item.key === key) {
            return callback(item, index, arr)
          }
          if (item.children) {
            return loop(item.children, key, callback)
          }
        })
      }
      const data = [...this.contentList]
      // Find dragObject
      let dragObj
      loop(data, dragKey, (item, index, arr) => {
        arr.splice(index, 1)
        dragObj = item
      })
      // 在同级拖动dropPosition为1,往里面拖动为0,往同级的第一个元素拖动是-1
      if (!info.dropToGap) {
        // Drop on the content
        loop(data, dropKey, (item) => {
          item.children = item.children || []
          // where to insert 示例添加到尾部，可以是随意位置
          item.children.push(dragObj)
          this.treeFormData.parentid = item.id
          this.treeFormData.sortid = -1
        })
      } else if (
        (info.node.children || []).length > 0 && // 有children
        info.node.expanded && // Is expanded
        dropPosition === 1 // 在底部间隙上
      ) {
        loop(data, dropKey, (item) => {
          item.children = item.children || []
          // where to insert 示例添加到尾部，可以是随意位置
          item.children.unshift(dragObj)
        })
      } else {
        let ar
        let i
        loop(data, dropKey, (item, index, arr) => {
          ar = arr
          i = index
        })

        if (dropPosition === -1) {
          ar.splice(i, 0, dragObj)
          this.treeFormData.parentid = ar[i + 1]
            ? ar[i + 1].pid
            : info.dropToGap
              ? 0
              : 0
          this.treeFormData.sortid = ar[i + 1] ? ar[i + 1].sortid : -1
        } else {
          ar.splice(i + 1, 0, dragObj)
          this.treeFormData.parentid = 0
          this.treeFormData.sortid = -1
          if (dropPosition === 1) {
            this.treeFormData.parentid = ar[i + 1]
              ? dragObj.pid == ar[i].pid
                ? dragObj.pid
                : ar[i].pid
              : 0
            this.treeFormData.sortid = ar[i + 2] ? ar[i + 2].sortid : -1
          }
        }
      }

      // console.log("dropPosition", dropPosition)
      // console.log("treeFormData", this.treeFormData)
      // console.log("contentList", this.contentList)
      // console.log("dragObj", dragObj) //获得拖动的数组

      this.contentList = data
      this.treeFormData.id = dragObj.id
      this.treeFormData.bookid = dragObj.bookId
      this.treeFormData.name = dragObj.name
      this.treeFormData.userid = this.$store.getters.id
      this.$http
        .put("v1/learnonly/directory", this.treeFormData)
        .then((response) => {
          if (!response.data) return this.$message.error("移动失败")
          this.onSelect()
        })
    },

    showRight (item) {
      console.log(item)
    },
    // 请求右侧目录详情列表
    getBooklist (item) {
      if (item !== undefined) {
        this.rightName = item.title
        this.directoryid = item.id
      }
      this.$http
        .get("v1/learnonly/getExercisesQuestions/getExerciseUploadList", {
          params: {
            userid: this.$store.getters.id,
            directoryid: this.directoryid,
            bookid: this.$route.query.bookid
          },
        })
        .then((response) => {
          if (response.data) {
            this.exerciseList = response.data
            this.noData = false
          } else {
            this.noData = true
          }
          $(window).scrollTop(0)
        })
    },
    // 获取作业类型
    getType () {
      this.$http
        .get("v1/learnonly/getExercisesQuestions/getJfExerciseType")
        .then((response) => {
          this.typeList = response.data.data
        })
    },
    // 删除作业
    deleteExercise (i) {
      this.$confirm({
        title: "确认删除该作业吗？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.$http
            .get("v1/learnonly/getExercisesQuestions/deleteExercise", {
              params: {
                userid: this.$store.getters.id,
                exerciseid: i.id, //作业id
              },
            })
            .then((response) => {
              if (response.status == 200) {
                if (response.data == "true") {
                  this.$message.success("删除成功")
                } else {
                  this.$message.error("删除失败")
                }
                this.getBooklist()
              }
            })
        },
        onCancel: () => {
          this.$message.info("已取消")
        },
      })
    },
    // 上传文件
    getFromData (item) {
      this.uploadFormData = {
        userid: this.$store.getters.id,
        bankid: this.$route.query.bankid,
        bookid: this.$route.query.bookid,
        directoryid: this.directoryid,
        state: 1,
        typeid: item.id,
      }
    },
    // 检查文档大小
    checkSizeFile (file) {
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message.error("文档大小超过最大限制5M，请酌情拆分文档!")
      } else {
        this.loadLoading = true
      }
      return isLt2M
    },
    handleChange (info) {
      if (info.file.status === "done") {
        if (info.file.response.result === true) {
          this.loadLoading = false
          this.$message.success("上传成功")
          this.getBooklist()
        } else {
          this.loadLoading = false
          var errorMsg = info.file.response.message
          this.$message.error(errorMsg ? errorMsg : "上传失败")
          info.fileList.splice(info.fileList.indexOf(info.file), 1);
        }
      } else if (info.file.status === "error") {
        this.loadLoading = false
        this.$message.error("网络故障")
        info.fileList.splice(info.fileList.indexOf(info.file), 1);
      }
    },
    // 获取弹出框试题内容
    showDrawer (i) {
      console.log('=====打印i', i)
      this.catalogvals = ""
      this.visible = true
      this.poptitle = i.exerciseName
      this.stageid = i.stageId
      this.subjectid = i.subjectId
      this.popdataList = i
      this.$http
        .get("v1/learnonly/getExercisesQuestions/getQuestionListWeb", {
          params: {
            userid: this.$store.getters.id, //	当前老师id
            exerciseid: i.id, //作业id
            stageid: i.stageId, //学段id
            subjectid: i.subjectId, //学科id
          },
        })
        .then((response) => {
          if (response.data.data.length != 0) {
            for (let i in response.data.data) {
              // 删除第一项  ‘未知’
              delete response.data.data[i].difficultyTypeIdsAndNames[0]
              response.data.data[i].tagShow = false
              // response.data.data[i].selectTree = undefined
            }
            this.questionList = response.data.data

            this.typeIdsAndNames = response.data.data[0].typeIdsAndNames
            this.difficultyTypeIdsAndNames =
              response.data.data[0].difficultyTypeIdsAndNames
          } else {
            this.questionList = []
          }
          this.getVersions()
        })
    },
    // 关闭修改作业状态
    onClose () {
      this.visible = false
      var arr = []
      for (let i = 0; i < this.questionList.length; i++) {
        var stateType =
          this.questionList[i].typeName != "" &&
          this.questionList[i].typeName != undefined &&
          this.questionList[i].difficultyName != "" &&
          this.questionList[i].difficultyName != undefined &&
          this.questionList[i].versionChapteNameList.length !== 0
        // &&  this.questionList[i].knowledgepoints.length !== 0
        arr.push(stateType)
      }
      console.log(arr)
      var flag = arr.every((item) => {
        return item
      })
      this.$http
        .post("v1/learnonly/upload/detail/qeditor", {
          exerciseid: this.questionList[0].exerciseId,
          stateid: flag ? 3 : 2,
        })
        .then(() => { })
      setTimeout(() => {
        this.$http
          .get("v1/learnonly/getExercisesQuestions/getExerciseUploadList", {
            params: {
              userid: this.$store.getters.id,
              directoryid: this.directoryid,
              bookid: this.$route.query.bookid,
            },
          })
          .then((response) => {
            if (response.data) {
              this.exerciseList = response.data
              this.noData = false
            } else {
              this.noData = true
            }
            //$(window).scrollTop(0)
          })
      }, 200)
      this.questionList = []
      this.treeList = []
      this.versionName = undefined
      this.allSelectInfo = undefined
      this.allTypeName = undefined
      this.allDifficulty = undefined
    },
    // 选择题型
    changeType (event, item) {
      this.typeActive = event
      this.questionid = item.id
      this.difficultyActive = ""
      this.catalogvals = ""
      this.typeId = ""
      this.inputValue = ""
      this.saveTitle()
    },
    // 选择难度
    changeDifficulty (event, item) {
      this.difficultyActive = event
      this.questionid = item.id
      this.typeActive = ""
      this.catalogvals = ""
      this.typeId = ""
      this.inputValue = ""
      this.saveTitle()
    },
    // 获取版本库start
    getVersions () {
      this.$http
        .get("v1/learnonly/getExercisesQuestions/getVersions", {
          params: {
            stageid: this.stageid,
            subjectid: this.subjectid,
          },
        })
        .then((response) => {
          this.versionsList = response.data.data
          this.versionsLists = response.data.data
          
          this.typeId = 2
          this.questionList.forEach((item) => {
            item.versionName = this.versionsList["综合库"][
              Object.keys(this.versionsList["综合库"])[0]
            ]
            item.chapterid = 2
          })

          this.versionid = Object.keys(this.versionsList["综合库"])[0]

          if (this.versionid == undefined) {
            this.typeId = 1
            this.versionid = Object.keys(this.versionsList["同步库"])[0]
            this.questionList.forEach((item) => {
              item.versionName = this.versionsList["同步库"][
                Object.keys(this.versionsList["同步库"])[0]
              ]
              item.chapterid = 1
            })
          }

          //重新赋值
          this.questionList.forEach((item) => {
            if (item.versionChapteNameList && item.versionChapteNameList.length > 0) {
              let id = item.versionChapteNameList[0].id
              let name = item.versionChapteNameList[0].name
              item.versionName = name.split("/")[0]
              item.chapterid = id.indexOf("textbook_") ? 1 : 2
            }
          })

          this.getNodetreeNext(true, {}, 3)
        })
    },
    // 选择同步库
    changeTextbook (index, item, items) {
      console.log(item)
      this.versionid = index
      this.typeId = 1
      this.selectList = item
      item.chapterid = 1
      item.selectTree = []
      item.versionName = items
      this.allSelectInfo = undefined
      this.versionName = undefined
      this.getNodetreeNext(false, item)
    },
    // 选择综合库
    changeOutline (index, item, items) {
      this.versionid = index
      this.typeId = 2
      this.selectList = item
      item.chapterid = 2
      item.selectTree = []
      item.versionName = items
      this.allSelectInfo = undefined
      this.versionName = undefined
      this.getNodetreeNext(false, item)
    },
    getNodetreeNext (flag, item, state) {
      this.$http
        .get("v1/learnonly/getExercisesQuestions/getNodetree", {
          params: {
            stageid: this.stageid,
            subjectid: this.subjectid,
            versionid: this.versionid,
            typeid: this.typeId,
          },
        })
        .then((response) => {
          this.treeList = this.traverseList(response.data.data.list, true)
          for (let i = 0; i < this.questionList.length; i++) {
            if (flag) {
              if (state != 3) {
                this.questionList[i].versionName = this.versionName
              }
              this.questionList[i].treeList = this.treeList
            }
            if (this.questionList[i].id == this.selectList.id) {
              this.questionList[i].treeList = this.treeList
            }
          }
          if (!flag) {
            this.treeList = []
            item.selectTree = []
            item.versionChapteNameList.forEach((ele) => {
              item.selectTree.unshift({
                label: ele.name,
                value: ele.id.split("_")[1],
              })
            })
          } else {
            if (state != 3) {
              this.questionList.forEach((item) => {
                item.selectTree = []
              })
            } else {
              this.treeList = []
            }
          }
          console.log("questionList", this.questionList)
          this.$forceUpdate(this.questionList)
        })
    },
    traverseList (data, flag) {
      for (var a in data) {
        data[a].children = data[a].next
        data[a].title = data[a].name
        data[a].value = data[a].id
        data[a].key = data[a].id
        // data[a].disabled = flag
        data[a].showedit = false
        // data[a].disableCheckbox = flag
        data[a].checkable = flag
        data[a].scopedSlots = { title: "custom" }
        if (data[a].next.length) {
          this.traverseList(data[a].next, false)
        }
      }
      return data
    },
    onChange (checkedInfo, lable, extra, item) {
      console.log(checkedInfo)
      console.log(lable)
      console.log(extra)
      console.log(item)
      item.selectTree = checkedInfo
      this.questionid = item.id
      this.typeActive = ""
      this.difficultyActive = ""
      this.inputValue = ""
      this.catalogvals = ""
      console.log(item.versionChapteNameList)
      console.log("checkedInfo", checkedInfo)
      if (item.chapterid == 1) {
        // for (let i = 0; i < checkedInfo.length; i++) {
        //   this.catalogvals += "textbook_" + checkedInfo[i].value + ","
        // }
        this.catalogvals = "textbook_" + extra.triggerValue
      } else if (item.chapterid == 2) {
        // for (let i = 0; i < checkedInfo.length; i++) {
        //   this.catalogvals += "outline_" + checkedInfo[i].value + ","
        // }
        this.catalogvals = "outline_" + extra.triggerValue
      }
      // this.catalogvals = this.catalogvals.substring(
      //   0,
      //   this.catalogvals.lastIndexOf(",")
      // )
      console.log(this.catalogvals)
      console.log("====================================")
      console.log(this.catalogvals)

      if (extra.checked) {
        this.saveTitle(false, lable, item)
      } else {
        // let catalogvals = ""
        // if (item.chapterid == 1) {
        //   for (let i = 0; i < extra.preValue.length; i++) {
        //     catalogvals += "textbook_" + extra.preValue[i].value + ","
        //   }
        // } else if (item.chapterid == 2) {
        //   for (let i = 0; i < extra.preValue.length; i++) {
        //     catalogvals += "outline_" + extra.preValue[i].value + ","
        //   }
        // }
        // catalogvals = catalogvals.substring(0, catalogvals.lastIndexOf(","))

        // console.log(catalogvals)
        let curItem = item.versionChapteNameList.find((ele) => {
          return ele.id.includes(extra.triggerValue)
        })
        this.$http
          .delete("v1/learnonly/getExercisesQuestions/deleteCategory", {
            params: {
              questionid: item.id,
              catalogvals:
                curItem.id.split("_")[0] == "textbook"
                  ? "textbook_" + extra.triggerValue
                  : "outline_" + extra.triggerValue, //作业id
            },
          })
          .then((response) => {
            if (response.status == 200) {
              if (response.data.code == 200) {
                this.$http
                  .get(
                    "v1/learnonly/getExercisesQuestions/getQuestionListWeb",
                    {
                      params: {
                        userid: this.$store.getters.id, //	当前老师id
                        exerciseid: this.popdataList.id, //作业id
                        stageid: this.popdataList.stageId, //学段id
                        subjectid: this.popdataList.subjectId, //学科id
                      },
                    }
                  )
                  .then((response) => {
                    if (response.data.data.length != 0) {
                      let questionIdArr = this.questionid.split(",")
                      let res = response.data.data
                      for (let m = 0; m < res.length; m++) {
                        for (let n = 0; n < questionIdArr.length; n++) {
                          if (questionIdArr[n] == res[m].id) {
                            for (let o = 0; o < this.questionList.length; o++) {
                              if (this.questionList[o].id == res[m].id) {
                                this.questionList[o].versionChapteNameList =
                                  res[m].versionChapteNameList
                                this.questionList[o].typeName = res[m].typeName
                                this.questionList[o].difficultyName =
                                  res[m].difficultyName
                                this.$forceUpdate()
                              }
                            }
                          }
                        }
                      }
                    }
                  })
                console.log(response.data.message)
              } else {
                this.$message.error(response.data.message)
              }
            }
          })
      }
      //   console.log("====================================")
    },

    // 获取版本库over
    // 添加新标签
    showInput (item) {
      this.inputValue = ""
      for (let i = 0; i < this.questionList.length; i++) {
        if (this.questionList[i].id == item.id) {
          this.questionList[i].tagShow = !this.questionList[i].tagShow
        }
      }
      this.$forceUpdate(this.questionList)
    },
    handleInputConfirm (item) {
      this.questionid = item.id
      for (let i = 0; i < this.questionList.length; i++) {
        if (this.questionList[i].id == item.id) {
          this.questionList[i].tagShow = !this.questionList[i].tagShow
        }
      }
      if (this.inputValue != "") {
        item.knowledgepoints.push(this.inputValue)
        this.typeActive = ""
        this.difficultyActive = ""
        this.catalogvals = ""
        this.typeId = ""
        this.saveTitle()
      }
      this.$forceUpdate(this.questionList)
    },
    // 删除标签
    deleteTag (id, i) {
      this.$http
        .get("v1/learnonly/getExercisesQuestions/deletekP", {
          params: { questionid: id, knowledgepoints: i },
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.$http
              .get("v1/learnonly/getExercisesQuestions/getQuestionListWeb", {
                params: {
                  userid: this.$store.getters.id, //	当前老师id
                  exerciseid: this.popdataList.id, //作业id
                  stageid: this.popdataList.stageId, //学段id
                  subjectid: this.popdataList.subjectId, //学科id
                },
              })
              .then((response) => {
                if (response.data.data.length != 0) {
                  this.questionList = response.data.data
                  // if (this.selectList.id != undefined) {
                  //   for (let i = 0; i < this.questionList.length; i++) {
                  //     if (this.questionList[i].id == this.selectList.id) {
                  //       this.questionList[i].treeList = this.treeList
                  //     }
                  //   }
                  // }

                  let questionIdArr = this.questionid.split()
                  let res = response.data.data
                  for (let m = 0; m < res.length; m++) {
                    for (let n = 0; n < questionIdArr.length; n++) {
                      if (questionIdArr[n] == res[m].id) {
                        for (let o = 0; o < this.questionList.length; o++) {
                          if (this.questionList[o].id == res[m].id) {
                            this.questionList[o].versionChapteNameList =
                              res[m].versionChapteNameList
                            this.$forceUpdate()
                          }
                        }
                      }
                    }
                  }
                }
              })
            this.$message.success(response.data.message)
          } else {
            this.$message.error(response.data.message)
          }
        })
    },
    // 删除分类
    deleteSort (item, i) {
      this.$confirm({
        title: "确认删除该分类吗？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.$http
            .delete("v1/learnonly/getExercisesQuestions/deleteCategory", {
              params: {
                questionid: item.id,
                catalogvals: i.id, //作业id
              },
            })
            .then((response) => {
              if (response.status == 200) {
                if (response.data.code == 200) {
                  this.$http
                    .get(
                      "v1/learnonly/getExercisesQuestions/getQuestionListWeb",
                      {
                        params: {
                          userid: this.$store.getters.id, //	当前老师id
                          exerciseid: this.popdataList.id, //作业id
                          stageid: this.popdataList.stageId, //学段id
                          subjectid: this.popdataList.subjectId, //学科id
                        },
                      }
                    )
                    .then((response) => {
                      if (response.data.data.length != 0) {
                        console.log(item)
                        // this.questionList = response.data.data
                        let curItem = response.data.data.find((ele) => {
                          return ele.id == item.id
                        })
                        item.versionChapteNameList =
                          curItem.versionChapteNameList
                        // if (this.selectList.id != undefined) {
                        //   for (let i = 0; i < this.questionList.length; i++) {
                        //     if (this.questionList[i].id == this.selectList.id) {
                        //       this.questionList[i].treeList = this.treeList
                        //     }
                        //   }
                        // }
                      }
                    })
                  this.$message.success(response.data.message)
                } else {
                  this.$message.error(response.data.message)
                }
              }
            })
        },
        onCancel: () => {
          this.$message.info("已取消")
        },
      })
    },
    // 保存题目属性（实时保存）
    saveTitle (flag, lable, item) {
      if (flag) {
        let str = ""
        this.questionList.forEach((item) => {
          str += item.id + ","
        })
        str = str.substring(0, str.length - 1)
        this.questionid = str
        console.log(str)
      }
      var data = {
        questionid: this.questionid, //	题目id
        typeid: this.typeActive, //	题目类型id
        experienceddifficulty: this.difficultyActive, //难度类型id
        knowledgepoints: this.inputValue, //知识点
        catalogvals: this.catalogvals, //册章节
        chapterid: this.typeId,
        // chapterid: !flag ? this.typeId : item.chapterid,
      }
      this.$http
        .post("v1/learnonly/getExercisesQuestions/saveQuestionProperty", data)
        .then((response) => {
          if (response.data.code == 400) {
            this.$message.error(response.data.message)
          } else {
            // if (!flag) {
            //   // 选择树
            //   for (let j = 0; j < this.questionList.length; j++) {
            //     if (
            //       this.questionList[j].id == this.questionid &&
            //       this.catalogvals
            //     ) {
            //       console.log(this.questionList[j].versionChapteNameList)
            //       let a = this.questionList[j].versionChapteNameList.some(
            //         (item) => {
            //           return item.id == this.catalogvals
            //         }
            //       )
            //       console.log(a)
            //       if (!a) {
            //         this.questionList[j].versionChapteNameList.unshift({
            //           id: this.catalogvals,
            //           name: lable[lable.length - 1],
            //         })
            //       }
            //     }
            //   }
            //   return
            // }
            this.$http
              .get("v1/learnonly/getExercisesQuestions/getQuestionListWeb", {
                params: {
                  userid: this.$store.getters.id, //	当前老师id
                  exerciseid: this.popdataList.id, //作业id
                  stageid: this.popdataList.stageId, //学段id
                  subjectid: this.popdataList.subjectId, //学科id
                },
              })
              .then((response) => {
                if (response.data.data.length != 0) {
                  let questionIdArr = this.questionid.split(",")

                  let res = response.data.data
                  for (let m = 0; m < res.length; m++) {
                    for (let n = 0; n < questionIdArr.length; n++) {
                      if (questionIdArr[n] == res[m].id) {
                        for (let o = 0; o < this.questionList.length; o++) {
                          if (this.questionList[o].id == res[m].id) {
                            this.questionList[o].versionChapteNameList =
                              res[m].versionChapteNameList
                            this.questionList[o].typeName = res[m].typeName
                            this.questionList[o].difficultyName =
                              res[m].difficultyName
                            if (flag == "false" || flag == false) {
                              this.allSelectInfo = undefined
                              this.versionName = undefined
                            } else {
                              // this.questionList[o].selectTree = []
                            }
                            this.$forceUpdate()
                          }
                        }
                      }
                    }
                  }
                  // this.questionList = response.data.data
                  // if (this.selectList.id != undefined) {
                  //   for (let i = 0; i < this.questionList.length; i++) {
                  //     if (this.questionList[i].id == this.selectList.id) {
                  //       this.questionList[i].treeList = this.treeList
                  //     }
                  //   }
                  // }
                }
              })
          }
        })
    },
    // 调取编辑器
    editDraw (item) {
      this.quesid = item.id
      this.$http
        .get("v1/learnonly/upload/edit/qeditor/" + item.id)
        .then((response) => {
          // if (response) {
          //   this.pageData = response.data
          //   this.analysisData(response.data)
          //   this.analysisList(response.data)
          // }
          if(response.data.code == 500){
            this.$message.warning('当前题目无法编辑，请联系管理员', 1)
          }else{
            this.editvisible = true
            this.edittitle = this.poptitle + "（试题题号：" + item.id + "）"
            this.pageData = response.data
            this.analysisData(response.data)
            this.analysisList(response.data)
          }
        })
    },
    // 解析页面数据
    analysisData (data) {
      this.pageData = {
        quesid: this.quesid,
        bankid: data.rawQuestion.bankId, // 学科
        typeid: data.rawQuestion.typeId, // 题目类型
        diff: "", // 难易程度
        year: data.rawQuestion.year, // 年份
        stem: data.stem, // 题目
        answer: data.answer, // 答案
        explanation: data.explanation, // 解析
        catalogvals: "",
        tagtaxonomies: "",
        knowledgepoints: data.rawQuestion.knowledgePoints.split(","), // 知识点
        source: data.rawQuestion.source, // 来源
        level: data.rawQuestion.levelCode, // 等级
        apply: data.rawQuestion.applyCode, // 适用
        //mediaName: (data.mediaName) ? data.mediaName : "",// 听力媒体文件名
        mediaData: (data.mediaData) ? data.mediaData : "", // 听力文件JSON信息，这个接口返的mediaData是JSON
        mediaName: "",
        mediaSrc: "",
      }

      if (this.pageData.mediaData.length > 0) {
        let mediaJson = JSON.parse(this.pageData.mediaData)
        this.pageData.mediaName = mediaJson.name // 听力媒体文件名
        this.pageData.mediaSrc = mediaJson.location + mediaJson.fileName//听力文件播放地址
      }

      this.tags = this.pageData.knowledgepoints
    },
    // 解析页面数组
    analysisList (data) {
      console.log(data)
      var yearsData = []
      data.years.forEach((i, ikey) => {
        yearsData.push({ id: ikey, name: i + "年", value: i })
      })
      this.listData.years = yearsData
      this.listData.questionTypes = data.questionTypes
      this.listData.questionTypes.unshift({id:0,name:'未知'})
      this.listData.diffData.forEach((d) => {
        if (d.name == data.rawQuestion.experiencedDifficulty) {
          this.pageData.diff = d.id
        }
      })
    },
    // 修订
    saveChangeData () {
      this.pageData.knowledgepoints = this.tags.join(",")
      var data = this.pageData
      data.level = data.level.toString()
      data.apply = data.apply.toString()
      //data.mediaData = JSON.stringify(data.mediaData)
      if (!data.typeid) return this.$message.warning("请先选择题型", 1)
      this.$http
        .post("v1/learnonly/upload/upload2submit", data)
        .then((response) => {
          if (response.data.result == true) {
            this.$message.success("修订成功！", 1)
          } else if (response.data.state == 0) {
            this.editvisible = true
            return this.$message.warning("修订失败！", 1)
          } else if (response.data.result == false) {
            this.editvisible = true
            return this.$message.warning(response.data.error, 1)
          }
          this.$http
            .get("v1/learnonly/getExercisesQuestions/getQuestionListWeb", {
              params: {
                userid: this.$store.getters.id, //	当前老师id
                exerciseid: this.popdataList.id, //作业id
                stageid: this.popdataList.stageId, //学段id
                subjectid: this.popdataList.subjectId, //学科id
              },
            })
            .then((response) => {
              if (response.data.data.length != 0) {
                this.questionList = response.data.data
              }
            })
          this.editvisible = false
        })
    },
    ready (editorInstance) {
      
    },
    onCloseedit () {
      this.editvisible = false
    },
    goBack () {
      window.history.go(-1)
    },

    allSelectChange (value, options, extra) {
      console.log(value)
      console.log(options)
      console.log(extra)
      this.typeActive = ""
      this.experienceddifficulty = ""

      console.log(this.allSelectInfo)
      if (!extra) {
        // 0: 题型选择 1: 难度选择 2: 分类选择同步库选择(typeId为1) 3: 分类选择综合库选择(typeId为2)
        let val = value.split(",")[0]
        let state = value.split(",")[1]
        console.log(val)
        console.log(state)

        if (state == 0) {
          this.typeActive = val
          this.saveTitle(true)
        } else if (state == 1) {
          this.difficultyActive = val
          this.saveTitle(true)
        } else if (state == 2) {
          this.versionid = val
          this.typeId = 1
          this.allSelectInfo = undefined
          this.versionName = options.key.split(",")[1]
          this.questionList.forEach((item) => {
            item.chapterid = 1
          })
          this.getNodetreeNext(true)
        } else if (state == 3) {
          console.log("33333333333")
          this.versionid = val
          this.typeId = 2
          this.allSelectInfo = undefined
          this.versionName = options.key.split(",")[1]
          this.questionList.forEach((item) => {
            item.chapterid = 2
          })
          this.getNodetreeNext(true)
        }
      } else {
        // 树选择
        if (extra.checked) {
          console.log(this.catalogvals)
          this.catalogvals = ""
          if (this.typeId == 1) {
            for (let i = 0; i < value.length; i++) {
              this.catalogvals += "textbook_" + value[i].value + ","
            }
          } else if (this.typeId == 2) {
            for (let i = 0; i < value.length; i++) {
              this.catalogvals += "outline_" + value[i].value + ","
            }
          }
          this.catalogvals = this.catalogvals.substring(
            0,
            this.catalogvals.lastIndexOf(",")
          )

          this.saveTitle(true)
        } else {
          let str = ""
          this.questionList.forEach((item) => {
            str += item.id + ","
          })
          str = str.substring(0, str.length - 1)
          this.questionid = str
          console.log(str)
          this.$http
            .delete("v1/learnonly/getExercisesQuestions/deleteCategory", {
              params: {
                questionid: this.questionid,
                catalogvals:
                  this.typeId == 1
                    ? "textbook_" + extra.triggerValue
                    : "outline_" + extra.triggerValue, //作业id
              },
            })
            .then((response) => {
              if (response.status == 200) {
                if (response.data.code == 200) {
                  this.$http
                    .get(
                      "v1/learnonly/getExercisesQuestions/getQuestionListWeb",
                      {
                        params: {
                          userid: this.$store.getters.id, //	当前老师id
                          exerciseid: this.popdataList.id, //作业id
                          stageid: this.popdataList.stageId, //学段id
                          subjectid: this.popdataList.subjectId, //学科id
                        },
                      }
                    )
                    .then((response) => {
                      if (response.data.data.length != 0) {
                        let questionIdArr = this.questionid.split(",")
                        let res = response.data.data
                        for (let m = 0; m < res.length; m++) {
                          for (let n = 0; n < questionIdArr.length; n++) {
                            if (questionIdArr[n] == res[m].id) {
                              for (
                                let o = 0;
                                o < this.questionList.length;
                                o++
                              ) {
                                if (this.questionList[o].id == res[m].id) {
                                  this.questionList[o].versionChapteNameList =
                                    res[m].versionChapteNameList
                                  this.questionList[o].typeName =
                                    res[m].typeName
                                  this.questionList[o].difficultyName =
                                    res[m].difficultyName
                                  this.$forceUpdate()
                                }
                              }
                            }
                          }
                        }
                      }
                    })
                  console.log(response.data.message)
                } else {
                  this.$message.error(response.data.message)
                }
              }
            })
        }

        this.questionList.forEach((item) => {
          item.selectTree = value
        })
      }
    },


    //移除音频
    removeMedia () {
      this.pageData.mediaData = ""
      this.pageData.mediaName = ""
      this.pageData.mediaSrc = ""
      this.$message.warning("音频已删除")
    },
    //上传音频
    beforeUploadMedia (file, fileList) {

      if (fileList.length > 1) {
        this.$message.error("只能传1个音频文件")
        return false
      }

      const checkFileSizeOK = file.size / 1024 / 1024 <= 10
      if (!checkFileSizeOK) {
        this.$message.error(file.name + "大小超过10M，请重新选择")
        return false
      }

      this.uploadMediaData = file.mediaFileData
      this.isUploading = true
      this.loadingText = "上传中..."
      //this.uploadBoxCanClose = false//上传过程中抽屉不能关闭
      return true

    },

    uploadMediaHandleChange (info) {
      if (info.file.status === "done") {
        if (info.file.response.code === 200) {
          this.isUploading = false
          //this.uploadBoxCanClose = true
          //this.uploadBoxVisible = false
          this.$message.success("音频文件上传成功")
          this.uploadMediaSuccess(info.file.response.data)
        } else {
          this.isUploading = false
          //this.uploadBoxCanClose = true
          let errorMsg = info.file.response.message ? info.file.response.message : "上传失败"
          this.$message.error(errorMsg)

          info.fileList.splice(info.fileList.indexOf(info.file), 1);
        }

      } else if (info.file.status === "error") {
        this.isUploading = false
        //this.uploadBoxCanClose = true
        let errorMsg = "网络故障或超时"
        this.$message.error(errorMsg)

        info.fileList.splice(info.fileList.indexOf(info.file), 1);
      }
    },

    uploadMediaSuccess (responseData) {
      console.log("zhou", responseData)
      if (responseData) {
        let location = responseData.location
        let fileName = responseData.fileName
        let name = responseData.name
        this.pageData.mediaData = JSON.stringify(responseData)//这个上传接口返的mediaData是对象--》要转字符串
        this.pageData.mediaName = name
        this.pageData.mediaSrc = location + fileName
      }

    },


    //   这里 新增复制功能
    // 确定复制
    // confirmCopy(item){
    //   var directoryId=JSON.stringify(item.directoryId)
    //   this.$copyText(directoryId).then(res => {
    //       this.$message.success(
    //         `复制文档  "${item.exerciseName}"  成功`,
    //         2,
    //       )
    //   }).catch(err => {
    //       this.$message.success(
    //         `复制文档  "${item.exerciseName}"  失败,请重试`,
    //         2,
    //       )
    //   })
    // },
    //   这里结束
  },
  updated () {
    if (window.MathJax) {
      window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub])
    }
    if (window.renderLatex) {
      if (this.$refs.contentQ)
        this.$refs.contentQ.forEach((q) => {
          window.renderLatex(q)
        })
    }
  },
  mounted () {
    const MathJax = document.createElement("script")
    MathJax.type = "text/javascript"
    MathJax.src =
      "https://mathjax.learnonly.com/MathJax.js?config=TeX-MML-AM_SVG"
    document.head.appendChild(MathJax)

    const MLCore = document.createElement("script")
    MLCore.type = "text/javascript"
    MLCore.src =
      "/resources/MLCore-2016.08.15.min.js?2019050809"
    document.head.appendChild(MLCore)
    this.onSelect()
  },
}
</script>

<style scoped>
/* start */

/deep/.ant-tree-title span {
  margin-right: 10px;
}
/deep/.ant-tree-title a {
  margin-left: 3px;
}
/deep/.ant-tree-title input {
  width: 90px;
  height: 22px;
  border: 1px solid #e5e5e5;
  border-radius: 3px;
  margin-right: 10px;
}
.bookTitle {
  float: right;
  margin: 22px 15px;
}
/* over */
.common-style {
  overflow: hidden;
  clear: both;
}
.common-style .cont-left {
  width: 30%;
  min-height: 800px;
  float: left;
  padding: 20px 15px;
}
.cont-left .leftTree {
  width: 100%;
  overflow: auto;
}
.cont-left .addList {
  width: 100px;
  line-height: 32px;
  background: #1890ff;
  color: #fff;
  border-radius: 5px;
  font-size: 13px;
  cursor: pointer;
  text-align: center;
}
.common-style .cont-right {
  width: 70%;
  float: left;
  border-left: 8px solid #f0f2f5;
  min-height: 800px;
}
.cont-right h1 {
  border-bottom: 2px dotted #eee;
  padding: 15px 0 10px 25px;
  font-size: 16px;
}
.cont-right .div-list {
  padding: 10px 0 0 25px;
  clear: both;
}
.cont-right .div-list .div-box {
  position: relative;
  width: 23%;
  float: left;
  border: 1px solid #eee;
  margin: 0 10px 10px 0;
  padding: 10px 10px 0;
  text-align: center;
}
.cont-right .div-list .div-box span {
  position: absolute;
  top: -7px;
  right: -8px;
  width: 18px;
  height: 18px;
  line-height: 17px;
  color: #fff;
  background: #f5222d;
  cursor: pointer;
  border-radius: 50%;
}
.div-box .title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.cont-right .div-list .upLoad {
  width: 23%;
  float: left;
  margin: 0 10px 10px 0;
  text-align: center;
}
.cont-right .div-list .upLoadfile {
  border: 1px solid #eee;
  line-height: 75px;
  cursor: pointer;
}
/deep/.ant-upload.ant-upload-select {
  width: 100%;
}
.cont-right .div-list .fontStyle {
  font-size: 12px;
  color: #999;
}
.batchSettings {
  position: absolute;
  right: 6em;
  top: 1em;
  z-index: 99;
  color: #409eff;
  cursor: pointer;
}

.ant-popover-inner {
  box-shadow: 2px 2px 10px rgb(0 0 0 / 35%);
}

.popover-content {
  width: 400px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}

.popover-content > div {
  flex: 50%;
}

.popover-content > p {
  margin-top: 0.5em;
  flex: 100%;
}

.drawerList {
  border: 1px solid rgba(218, 218, 218, 1);
  border-radius: 8px;
  /* background-color: rgba(242, 250, 255, 1); */
  margin-bottom: 10px;
  padding: 5px 10px;
}
.drawerList:first-child {
  margin-top: 70px;
}
.drawerList:hover {
  box-shadow: rgba(0, 0, 0, 0.25) 0px 1px 10px;
}
.drawerList .deafaultSort {
  overflow: hidden;
  width: 100%;
  padding-left: 6px;
  border-bottom: 1px dashed rgb(221, 221, 221);
}
.drawerList .deafaultSort > div {
  float: left;
}
.drawerList .answerStyle {
  clear: both;
  border-top: 1px dashed rgb(221, 221, 221);
  padding-top: 10px;
  font-size: 13px;
}
.redBorder {
  border-color: #f5222d;
}
.answerStyle p {
  margin-bottom: 5px !important;
}
/deep/.answerStyle p span p {
  display: inline;
}
.drawerList p {
  margin-bottom: 10px;
}
/deep/.ant-row {
  height: 20px;
}
.bodyLoad {
  position: absolute;
  width: 85%;
  height: 100vh;
  padding-left: 40%;
  padding-top: 10%;
}
.bodyLoad p {
  color: #1890ff;
  padding-top: 10px;
  margin-left: -10px;
  font-size: 16px;
  font-weight: 600;
}
.editPaperPage {
  width: 100%;
  height: 100%;
  margin: 125px auto 0;
}

.editPaperPage .ant-card {
  background: #f1f1f1;
  margin-bottom: 30px;
  border-radius: 5px;
  border: 1px solid #ccc;
  z-index: 1;
}
.btn-Group {
  position: fixed;
  top: 54px;
  z-index: 99;
  width: 940px;
  background: #fff;
  padding-top: 15px;
}
.edui-editor-toolbarbox {
  position: relative;
}
</style>
<style>
/* 抽屉 */
.ant-drawer-header {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  width: 98%;
}
.ant-drawer-body {
  padding: 0 24px 24px;
}
.ant-drawer-close-x {
  height: 50px;
  line-height: 42px;
}
.ant-select-sm .ant-select-selection--multiple {
  max-height: 24px;
}
.ant-select-selection--multiple {
  max-height: 32px;
}
.ant-select-tree-dropdown {
  max-height: 430px !important;
}
.ant-select-selection__choice__content {
  max-width: 90px !important;
}

.treeSelectDropdown {
  left: unset !important;
  right: 0px;
}
</style>
